export default __webpack_public_path__ + "static/media/DSAR_LOA_MoneyBarn.0edb3763.pdf";